import {IDesignSolution, IEntityAlert} from '../../models/common';
import {Observable} from 'rxjs';
import {ApplicationSpecActions} from '../../Redux/Actions/application-spec-actions';
import {FeatureEx} from '../../models/features/features';
import {FeatureFilterState} from '../../models/features/feature_const';
import {Component, OnInit} from '@angular/core';
import {ActionsService} from '../../Redux/Actions/actions.service';
import {select} from '@angular-redux/store';
import {ActivatedRoute, Router} from '@angular/router';
import {tassign} from 'app/common/utils';
import {ApplicationCatalogActions} from '../../Redux/Actions/application-catalog-actions';

@Component({
  selector: 'edsng-ic-grid',
  templateUrl: './ic-grid.component.html',
  styleUrls: [
    './ic-grid.component.css',
    './ic-grid-component.mobile.css',
    './ic-grid-component.tablet.css'
  ]
})
export class IcGridComponent implements OnInit {
  featureList: FeatureEx[] = [];

  errorSpecification: boolean = true;

  designSolutions: IDesignSolution[];
  @select(['appCatalog', 'designSolutions']) designSolutions$;
  @select(['appCatalog', 'selectedSolution']) selectedSolution$;
  @select(['appCatalog', 'unableToFindSolution']) unableToFindSolution$;
  @select(['appToolBar', 'direction']) direction$;
  @select(['appToolBar', 'sortField']) sortField$;
  @select(['appSpec', 'noteGlobal']) noteGlobal$: Observable<IEntityAlert>;
  @select(['appSpec', 'featuresFilter'])  featuresFilter$;
  @select(['appContext', 'frameMode']) inFrame$: Observable<boolean>;

  constructor(public act: ActionsService, protected route: ActivatedRoute, protected router: Router) {
  }

  ngOnInit() {
    this.act.sendAction(ApplicationCatalogActions.deselectSolution());

    this.noteGlobal$.subscribe(z => {
      setTimeout(() => {
        this.errorSpecification = z.hasError;
      }, 300);
    });
    this.designSolutions$.subscribe(x => {
      this.designSolutions = x;
    });

    this.featuresFilter$.subscribe(x => {
      this.featureList = x.filter( (f) => f.stateFilter !== 0 && !f.isCommon);
    });
  }


  selectedItem(event) {
    // console.debug('Selected item', event);
    // this.act.sendAction(ApplicationCatalogActions.selectSolution(event));
    this.router.navigate(['selected', event.key], {
      relativeTo: this.route.parent
    });
  }

  /**
   * funzione richiamata quando una feature viene eliminata dall'elenco di quelle presenti
   * @param f feature
   */
  deselectFeature(f) {
    const featEx: FeatureEx = tassign(f, {
      stateFilter: FeatureFilterState.NO_FILTER
    });
    this.act.sendAction(ApplicationSpecActions.updateFeature(featEx));
  }

  public onIntersection({ target, visible }: { target: Element; visible: boolean }, item: any): void {
    item["isInViewport"] = visible;
  }
}
